export const Shared = {
    className: 'panel-details-card',
    dataTestId: 'panel-details-card',
};

export interface ICreateData {
    type?: string;
    onCreate: (panelRef: string) => Promise<void>;
    onCancel: () => void;
}

export const COMPONENT_NAME = 'panel-config';

export default {};
